export const hasHostSlug = (window: Window) => {
  const host = window.location.host;
  const splitHost = host.split(".");
  const isDev = host.includes("localhost");
  if ((isDev && splitHost.length > 1) || (!isDev && splitHost.length > 2)) {
    return true;
  }
  return false;
};

export const hostSlug = (window: Window) => {
  const host = window.location.host;
  const splitHost = host.split(".");
  const isDev = host.includes("localhost");
  if ((isDev && splitHost.length > 1) || (!isDev && splitHost.length > 2)) {
    return splitHost[0];
  }
  return "";
};

export const getRequestSlug = (host: string) => {
  const splitHost = host.split(".");
  const isDev = host.includes("localhost");
  if ((isDev && splitHost.length > 1) || (!isDev && splitHost.length > 2)) {
    return splitHost[0];
  }
  return "";
};

export const reservedAppSlugs = ["app", "auth"];
